/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Row_ExportInputs */

const en_us2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export workouts (CSV)`)
};

const pt_br2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar treinos (CSV)`)
};

const es_419_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar entrenamientos (CSV)`)
};

const pt_pt2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar treinos (CSV)`)
};

const fr_fr2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les séances (CSV)`)
};

const de_de2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings exportieren (CSV)`)
};

const it_it2_history_transfer_row_export = /** @type {(inputs: History_Transfer_Row_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta allenamenti (CSV)`)
};

/**
* | output |
* | --- |
* | "Export workouts (CSV)" |
*
* @param {History_Transfer_Row_ExportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_row_export = /** @type {((inputs?: History_Transfer_Row_ExportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Row_ExportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_row_export(inputs)
	if (locale === "es-419") return es_419_history_transfer_row_export(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_row_export(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_row_export(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_row_export(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_row_export(inputs)
	return en_us2_history_transfer_row_export(inputs)
});
export { history_transfer_row_export as "history-transfer.row_export" }